import AvatarRing from "./AvatarRing";
import { SUBTITLE_ICONS } from "../icons";
import { TEXT_DARK } from "../theme";

export const BUBBLE_RADIUS = {
  rounded: "14px 14px 4px 14px",
  pill: "20px",
  sharp: "4px",
};

// One small renderer per cosmetic type, shared by the admin shop-builder
// (live preview while editing) and the player-facing shop (item cards).
function ShopItemPreview({ item, photoURL }) {
  if (item.type === "subtitle") {
    const Icon = item.config?.icon ? SUBTITLE_ICONS[item.config.icon] : null;
    const color = item.config?.color || TEXT_DARK;
    return (
      <div style={{
        width: "70px",
        textAlign: "center",
        fontSize: "0.75rem",
        fontWeight: "700",
        fontStyle: item.config?.italic ? "italic" : "normal",
        color,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "3px",
      }}>
        {Icon && <Icon size={14} color={color} />}
        <span>{item.config?.text || "(empty)"}</span>
      </div>
    );
  }

  if (item.type === "border") {
    return <AvatarRing photoURL={photoURL} size={40} item={item} />;
  }

  if (item.type === "bubble") {
    return (
      <div style={{
        background: item.config?.background || "#ccc",
        color: item.config?.color || "#fff",
        padding: "8px 12px",
        borderRadius: BUBBLE_RADIUS[item.config?.radius] || BUBBLE_RADIUS.rounded,
        fontSize: "0.75rem",
        fontWeight: item.config?.bold ? "800" : "600",
        whiteSpace: "nowrap",
      }}>
        hey!
      </div>
    );
  }

  return null;
}

export default ShopItemPreview;
